import { PARACATU_MARKET_ID, PATOS_DE_MINAS_MARKET_ID } from './brazil.js';
/** The Brazil reference tariff market (BR-TARIFF-02). */
export const BRAZIL_TARIFF_MARKET = 'br:sao-paulo';
const EFFECTIVE_FROM = '2026-01-01T00:00:00.000Z';
// Illustrative São Paulo economy→premium ladder, in BRL centavos.
const SAO_PAULO = {
    marketId: BRAZIL_TARIFF_MARKET,
    versionSuffix: 'v1',
    specs: [
        { categoryCode: 'moto', baseFareMinor: 300n, perKmMinor: 110n, perMinMinor: 20n, minimumFareMinor: 500n },
        { categoryCode: 'go', baseFareMinor: 450n, perKmMinor: 180n, perMinMinor: 35n, minimumFareMinor: 700n },
        { categoryCode: 'standard', baseFareMinor: 450n, perKmMinor: 180n, perMinMinor: 35n, minimumFareMinor: 700n },
        { categoryCode: 'comfort', baseFareMinor: 600n, perKmMinor: 240n, perMinMinor: 45n, minimumFareMinor: 1000n },
    ],
};
// Pilot: Paracatu (~95k inhabitants) — generated illustrative values, below the São Paulo ladder.
const PARACATU = {
    marketId: PARACATU_MARKET_ID,
    versionSuffix: 'illustrative-v1',
    specs: [
        { categoryCode: 'moto', baseFareMinor: 250n, perKmMinor: 95n, perMinMinor: 15n, minimumFareMinor: 450n },
        { categoryCode: 'go', baseFareMinor: 380n, perKmMinor: 150n, perMinMinor: 28n, minimumFareMinor: 600n },
        { categoryCode: 'standard', baseFareMinor: 380n, perKmMinor: 150n, perMinMinor: 28n, minimumFareMinor: 600n },
        { categoryCode: 'comfort', baseFareMinor: 520n, perKmMinor: 200n, perMinMinor: 38n, minimumFareMinor: 900n },
    ],
};
// Pilot: Patos de Minas (~160k inhabitants) — generated illustrative values, slightly above Paracatu.
const PATOS_DE_MINAS = {
    marketId: PATOS_DE_MINAS_MARKET_ID,
    versionSuffix: 'illustrative-v1',
    specs: [
        { categoryCode: 'moto', baseFareMinor: 260n, perKmMinor: 100n, perMinMinor: 16n, minimumFareMinor: 480n },
        { categoryCode: 'go', baseFareMinor: 400n, perKmMinor: 155n, perMinMinor: 30n, minimumFareMinor: 650n },
        { categoryCode: 'standard', baseFareMinor: 400n, perKmMinor: 155n, perMinMinor: 30n, minimumFareMinor: 650n },
        { categoryCode: 'comfort', baseFareMinor: 540n, perKmMinor: 210n, perMinMinor: 40n, minimumFareMinor: 950n },
    ],
};
/** The pilot ride categories, in ladder order (the same ladder in every Brazil tariff table). */
export const BRAZIL_PILOT_CATEGORY_CODES = PARACATU.specs.map((s) => s.categoryCode);
function rulesOf(table) {
    return table.specs.map((t) => ({
        pricingVersion: `${table.marketId}-${t.categoryCode}-${table.versionSuffix}`,
        currency: 'BRL',
        marketId: table.marketId,
        categoryCode: t.categoryCode,
        effectiveFrom: EFFECTIVE_FROM,
        baseFareMinor: t.baseFareMinor,
        distanceRate: { minorUnits: t.perKmMinor, perUnit: 1000 },
        timeRate: { minorUnits: t.perMinMinor, perUnit: 60 },
        minimumFareMinor: t.minimumFareMinor,
        quoteTtlSeconds: 300,
        audit: { createdAt: EFFECTIVE_FROM, createdBy: 'seed:pricing' },
    }));
}
/** The illustrative pilot tariffs for `br:paracatu` and `br:patos-de-minas` (currency BRL). */
export function brazilPilotTariffRules() {
    return [...rulesOf(PARACATU), ...rulesOf(PATOS_DE_MINAS)];
}
/**
 * Every Brazil ride tariff rate table as versioned `PricingRuleSet`s (currency BRL): the São Paulo reference ladder
 * first, then the two pilot markets. The pack seed publishes all of them as governed ACTIVE rules.
 */
export function brazilTariffRules() {
    return [...rulesOf(SAO_PAULO), ...brazilPilotTariffRules()];
}
//# sourceMappingURL=tariffs.js.map